import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'buefy/dist/buefy.css';

Vue.config.productionTip = false

import Buefy from "buefy";
Vue.use(Buefy, {
	defaultIconPack: "fa",
});

import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/js/all.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPaypal } from '@fortawesome/free-brands-svg-icons';
library.add(faPaypal);
Vue.component('fa', FontAwesomeIcon);

import refresh from '@/services/refresh';
Vue.use(refresh);

//@ts-ignore
import colors from '@/assets/chartColors/colors.js';
Vue.prototype.$getColors = colors.GetColors;
Vue.prototype.$USERURL = process.env.VUE_APP_UserUrl;

const moment = require('moment')
require('moment/locale/es')

Vue.use(require('vue-moment'));

import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
	defaultHtml: false,
})

import '@/assets/css/global.scss';

//@ts-ignore
import JsonCSV from 'vue-json-csv'
Vue.component('downloadCsv', JsonCSV)

import PayPal from '@/services/v-paypal';
Vue.use(PayPal, {
	clientId: process.env.VUE_APP_PAYPAL_CLIENTID + "&disable-funding=credit&vault=true",
	env: process.env.NODE_ENV == "production" ? "production" : "sandbox"
});

import Axios from "axios";
Vue.prototype.$http = Axios;
Axios.defaults.baseURL = process.env.VUE_APP_CC_API;

const token = localStorage.getItem("CTC_AUTH_TOKEN");
if (token) {
	Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
}

import math from '@/services/math.ts';
Vue.use(math);

//@ts-ignore
import html2canvas from 'vue-html2canvas';
Vue.use(html2canvas);
import domtoimage from 'dom-to-image';
Vue.prototype.$domtoimage = domtoimage;
import Export from "@/services/export.ts";
Vue.use(Export, domtoimage);

import aircraftTable from "@/components/aircraft/aircraftTable.vue";
Vue.component('aircraftTable', aircraftTable); //component name should be in camel-case

import crossDomainLogin from "@/services/crossDomainLogin.ts";
Vue.use(crossDomainLogin);

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
	config: { id: process.env.VUE_APP_GTAGID }
});

new Vue({
	router,
	store,
	created() {
		Axios.interceptors.request.use(
			config => {
				const token = localStorage.getItem("CTC_AUTH_TOKEN");
				if (token) {
					config.headers["Authorization"] = "Bearer " + token;
				}
				return config;
			},
			err => {
				Promise.reject(err);
			});

		//@ts-ignore
		var refreshPromises = [];
		var refreshing = false;
		Axios.interceptors.response.use(resp => {
			return resp;
		}, async (err) => {
			if (err.response.status === 401) {
				if (err.response.headers["token-expired"] == "true" && !refreshing) {
					refreshing = true;
					return new Promise((resolve, reject) => {
						var p1 =
							Axios.post("api/authentication/refresh", { token: localStorage.getItem("CTC_REFRESH_TOKEN") }).then(async (resp) => {
								store.dispatch("refresh", resp.data);
								refreshing = false;

								resolve(Axios.request(err.config));

							}).catch(e => {
								store.dispatch("logout");
								router.push({ name: "login" });
								reject(e);
							});
						refreshPromises.push(p1);
					})
				}
				else {
					//@ts-ignore
					return Promise.all(refreshPromises).then(r => {
						refreshing = false;
						return Axios.request(err.config);
					});
				}
				return err.response;
			}
			return Promise.reject(err);
		});
	},
	render: h => h(App)
}).$mount('#app')
